<script setup lang="ts">
import { ref } from 'vue'
import AgentSetupDialog from './AgentSetupDialog.vue'
import Button from 'primevue/button'
import { useRouter } from 'vue-router'
import type { AuthUser } from '@/api/types'

defineProps<{ user: AuthUser | null }>()
const emit = defineEmits<{ (e: 'logout'): void }>()
const router = useRouter()
const agentSetupVisible = ref(false)

function goProfile(): void {
  router.push('/profile/')
}
</script>

<template>
  <header class="topbar">
    <div class="brand-block">
      <div class="brand-title">Мотыга</div>
      <div class="brand-subtitle"><span class="drop">M</span>ass <span class="drop">T</span>ext <span class="drop">G</span>eneration</div>
    </div>
    <div class="nav-spacer">
      <span class="user user-link" v-if="user" @click="goProfile" title="Open profile">{{ user.phone }} ({{ user.primary_role_slug || 'no-role' }})</span>
      <Button v-if="user" label="Настроить агента" icon="pi pi-sparkles" severity="secondary" size="small" @click="agentSetupVisible = true" />
      <Button label="Profile" severity="secondary" size="small" @click="goProfile" />
      <Button label="Logout" severity="secondary" size="small" @click="emit('logout')" />
    </div>
  </header>
  <AgentSetupDialog v-model:visible="agentSetupVisible" />
</template>

<style scoped>
.brand-block {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.brand-title {
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: 0.01em;
}
.brand-subtitle {
  font-style: italic;
  font-size: 0.78rem;
  color: var(--muted);
}
.brand-subtitle .drop {
  font-weight: 700;
  font-style: normal;
  color: var(--primary);
}
.user-link {
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.user-link:hover {
  color: var(--primary);
}
@media (max-width: 760px) {
  .topbar { flex-wrap: wrap; gap: 0.75rem; }
  .topbar .nav-spacer { flex-wrap: wrap; gap: 0.5rem; }
  .topbar .user { flex-basis: 100%; }
}
</style>
